import type { ComputedRef } from 'vue'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'

import { useListsStore } from '@shared/model'

interface TutorAttendanceRateOptionsReturn {
  statusOptions: ComputedRef<AppSelectOption[]>
  reasonOptions: ComputedRef<AppSelectOption[]>
}

const toOptions = (record: Record<string, string>): AppSelectOption[] =>
  Object.entries(record).map(([value, text]) => ({ value, text }))

export const useTutorAttendanceRateOptions = (): TutorAttendanceRateOptionsReturn => {
  const listsStore = useListsStore()

  const statusOptions = computed<AppSelectOption[]>(() =>
    toOptions(listsStore.getLists?.booking?.status_finished_for_customer ?? {}),
  )
  const reasonOptions = computed<AppSelectOption[]>(() =>
    toOptions(listsStore.getLists?.tutor_attendance_rate?.reason ?? {}),
  )

  return {
    statusOptions,
    reasonOptions,
  }
}
